<script setup>
import { ref } from 'vue';
import { router } from '@inertiajs/vue3';
import Locale from '@/Pages/Shared/Locale.vue';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;

let urlNamePrefix = '';
let availableLocales = [];

if (organisation) {
    urlNamePrefix = "gi.";
    availableLocales = organisation.available_locales;
} else if (!organisation && !programme) {
    urlNamePrefix = "platform.";
} else {
    availableLocales = programme.available_locales;
}

const logout = () => {
    router.post(route(urlNamePrefix+'logout'));
};

const organisationLogo = (organisation && organisation.logo) ? '/storage/'+ organisation.logo : null;
const programmeLogo = (programme && programme.logo) ? '/storage/'+ programme.logo : null;

</script>
<template>
    <header id="sos-auditor-header" class="bg-white">

        <div class="container mx-auto flex flex-row items-center justify-between w-full pt-5 pb-5 bg-white">
            <!-- <Link :href="route(urlNamePrefix+'login')" class="logos flex flex-row items-center" v-if="urlNamePrefix != 'platform.'"> -->
                <span v-if="$page.props.auth.user" class="sm:w-4"></span>
                <span class="image-wrapper sm:ml-5" v-if="programmeLogo">
                    <img :src="programmeLogo" :alt="programme.name" class="logo-programme" />
                </span>
                <span class="image-wrapper" v-if="organisationLogo">
                    <img :src="organisationLogo" :alt="organisation.name" class="logo-organisation sm:ml-10 sm:mr-10" />
                </span>
            <!-- </Link> -->
            <div id="sos-header-menu">

                <div class="sos-programme-dashboard-menu flex flex-row items-center" v-if="Object.keys(availableLocales).length > 1">
                    <!-- Language Dropdown -->
                    <Locale :currentLocale="$i18n.locale" />
                </div>
            </div>
        </div>
    </header>

</template>
